import { encodePayload } from './utils';
import { EventsCollector } from './EventsCollector';
import { logPayload } from './log';
let globalOptions;
let eventsCollector;
export function configureSendEvents(options) {
    globalOptions = options;
    const { immediate, ...eventsCollectorProps } = globalOptions;
    if (eventsCollector) {
        eventsCollector.stop();
    }
    eventsCollector = new EventsCollector(eventsCollectorProps);
}
export function sendEvent(payload, options) {
    if (!globalOptions) {
        throw new Error('sendEvent: globalOptions not configured, pls configure it with the configureSendEvents function');
    }
    const { url, immediate: globalImmediate } = globalOptions;
    if (!url) {
        throw new Error('sendEvent: url not configured, pls configure it with the configureSendEvents function');
    }
    logPayload(payload);
    const { immediate } = options || {};
    if (immediate || globalImmediate) {
        fetch(url, { method: 'POST', body: encodePayload(payload) });
    }
    else if (eventsCollector) {
        eventsCollector.addEvent(payload);
    }
}
